import React from 'react';

import './WhyChooseUs.css';

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us-section">
      <div className="container">
        <h2 className="section-titleW">Why Choose NeuroverseAI?</h2>
        


        <p className="section-intro">
          Our SAP consulting services in the USA are designed to streamline your business operations and drive innovation. As a top SAP consulting company, we offer comprehensive solutions tailored to your organization's needs. Our SAP staffing agency in the USA provides expert professionals to enhance your team's capabilities. Partnering with leading SAP consulting firms, we ensure the successful implementation and support of SAP systems. Our SAP staffing augmentation services in the USA are designed to seamlessly integrate with your existing team, providing the expertise needed for your projects.
        </p>
        <div className="services-grid">
          {/* Service Card 1: SAP Consulting */}
          <div className="service-card">
            <img src="https://avas.live/artificial-intelligence/wp-content/uploads/sites/71/2023/09/solutions-1.png" alt="SAP Consulting Icon" className="card-icon" />
            <h3 className="card-title">SAP Consulting</h3>
            <p className="card-description">
              Empowering businesses with tailored SAP solutions for streamlined processes and sustained growth.
            </p>
            <a href="/best-sap-consulting-services-usa" className="card-button">Learn More</a>
          </div>

          {/* Service Card 2: AI/ML */}
          <div className="service-card">
            <img src="https://avas.live/artificial-intelligence/wp-content/uploads/sites/71/2023/09/certified-expert-1.png" alt="AI/ML Icon" className="card-icon" />
            <h3 className="card-title">AI/ML</h3>
            <p className="card-description">
              Transforming data into intelligent decisions with advanced AI and ML solutions.
            </p>
            <a href="/ai-and-ml-consulting-services" className="card-button">Learn More</a>
          </div>

          {/* Service Card 3: Staff Augmentation */}
          <div className="service-card">
            <img src="https://avas.live/artificial-intelligence/wp-content/uploads/sites/71/2023/09/247support-1.png" alt="Staff Augmentation Icon" className="card-icon" />
            <h3 className="card-title">Staff Augmentation</h3>
            <p className="card-description">
              Enhancing your SAP capabilities with expert staff augmentation for seamless project execution.
            </p>
            <a href="/top-sap-staff-augmentation-services" className="card-button">Learn More</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
